import {isElectron} from "react-device-detect";
import { notify } from "../../components/blocks/Notify";
import { setLog } from "../../helpers/functions";
import { getIpcRenderer } from '../../reducers/ipc-loader.js';
const WAIT = "WAIT";
const STANBY = "STANBY";
const BREATH = "BREATH";
const RESULT = "RESULT";
const END = "END";
const ALCO_FAIL = 'ALCO_FAIL';


class moduleAlcotester {
	/**
	 *    option = {
	 *	baudRate: 4800,
	 *	port: 'COM3', -port
	 *	delimiter: '$' - разделитель
	 *	}
	 *
	 *    callbackResult - f(String) куда вернуть результат алкотестера
	 *    callbackStatus - f(String) статус состояния алкотестера (WAIT,STANBY,BREATH,RESULT,END)
	 *    callbackError - f(String) обработка ошибки
	 *
	 *    после создания обьекта, следует использовать команду start()
	 */

	constructor(option, callbackStatus) {
		if (!isElectron) return;		
		this.baudRate = (option.baudRate === undefined) ? 4800 : option.baudRate;
		this.delimiterSimbol = (option.delimiter === undefined) ? '$' : option.delimiter;
		this.path = (option.port === undefined) ? 'COM3' : option.port;
		this.isOpen = false;
		this.status = null;
		this.portSerialListener = null;
		this.portErrorListener = null;
		try {						
			this.callbackStatus = (callbackStatus === undefined) ? (result) => {} : callbackStatus;
			getIpcRenderer().then((ipcRenderer)=>{
				if(ipcRenderer){				
					ipcRenderer.invoke('init-serial-port', {path:this.path,baudRate: this.baudRate, autoOpen: false,parserConfig:{ type:'delimiter',delimiter:this.delimiterSimbol}}).then(res=>{             				
						if(!res.success){					                       
						}                    
				});   
				this.open();
				}	
			});		
			
			     
		} catch (e) {
			e.typeError = 'ALCO_FAIL';
			let info = "Ошибка в moduleAlcotester";
			setLog(info, e);
			notify(info, 'error');
		}
	}


	/**
	 * Начать выполнение
	 * @returns {Promise.Promise}
	 */
	start() {
		return  new Promise((resolve, reject) => {	
			getIpcRenderer().then((ipcRenderer)=>{
				if(ipcRenderer){
					ipcRenderer.send('start-serial-listening',{path:this.path,useParser:true});
					this.portSerialListener = (event, data) => {
						if(data.path === this.path)
						{	
							let str = data.data.toString();
							let pos = str.indexOf(RESULT);					
							if (pos !== -1) {
								let lastAlco = this.parseResult(str);
								str = RESULT;

								resolve(lastAlco);
							}			
														
							if (str !== this.status) {
								this.status = str;						
								this.callbackStatus(this.status);
							}
						}
					} 
					ipcRenderer.on('serial-data', this.portSerialListener);
					this.portErrorListener = (event, data) => {
						if(data.path === this.path)
						{
							reject(data.error);
						}									
					};
					ipcRenderer.on('serial-error', this.portErrorListener );		
					ipcRenderer.invoke('write-serial-data',{path:this.path,data:'$START\r\n',encoding:'ascii'}).then(res=>{});		
				}	
			});			
		});
	}	
	
	open(){
		getIpcRenderer().then((ipcRenderer)=>{
			if(ipcRenderer){
				ipcRenderer.invoke('open-serial-port',{path:this.path}).then(res=>{    						
					if(res.success){
							this.isOpen = true;	
					}else{
						this.isOpen = false;
					}
				});  
			}
		});
	}

	close() {
		return  new Promise((resolve, reject) => {			
			getIpcRenderer().then((ipcRenderer)=>{
				console.log('close')
				if(ipcRenderer){
					ipcRenderer.invoke('close-serial-port',this.path);  
				}
					resolve();
			}).catch(()=>{
				reject();
			});
		
		});
	}	

	reset() {
		return  new Promise((resolve, reject) => {		
			getIpcRenderer().then((ipcRenderer)=>{
				if(ipcRenderer){
					if(this.portSerialListener){
						ipcRenderer.removeListener('serial-data',this.portSerialListener);
					}
					if(this.portErrorListener){
						ipcRenderer.removeListener('serial-error',this.portErrorListener);
					}
					ipcRenderer.send('stop-serial-listening',this.path);					
					ipcRenderer.invoke('write-serial-data',{path:this.path,data:'$RESET \r \n',encoding:'ascii'}).then(res=>{	
						console.log(res);
						if(!res.success)
						{
							reject(res.error);
						}
					});		
					resolve()
				}
			}).catch(()=>{reject();});		
				
		
		});
	}


	parseResult(str) {
		const regex = /\w+\,(?<value>[0-9]+\.[0-9]+)-(?<level>\w+)/;
		const found = str.match(regex);

		return parseFloat(found.groups.value);
	}

	checkStatus() {
		let isData = [];
		return  new Promise((resolve, reject) => {		
			getIpcRenderer().then((ipcRenderer)=>{
				if(ipcRenderer){
					try {						
							ipcRenderer.invoke('read-serial-data',{path:this.path,useParser:true,timeout:4000}).then(res => {					
							if(res.success)
							{
								isData.push(res.data);						
								if (isData.length > 0) {							
									resolve(true);								
								}else{							
									resolve(false);
								}
							}else{
								resolve(false);
							}
						});
						setTimeout(() => {
							if (isData.length === 0) resolve(false);
						}, 4000)
					} catch (e) {
						reject(e);
					}	
				}
			}).catch(()=>{reject()});		
		})
	}
	
}

export default moduleAlcotester;